import { Paper, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

function RepaymentHistorySkeleton() {
  return (
    <Paper sx={{ padding: 2, marginTop: 3 }}>
      <Typography variant="h6" gutterBottom>
        Repayment History
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Skeleton width="120px" />
            </TableCell>
            <TableCell>
              <Skeleton width="150px" />
            </TableCell>
            <TableCell align="right">
              <Skeleton width="100px" />
            </TableCell>
            <TableCell align="right">
              <Skeleton width="100px" />
            </TableCell>
            <TableCell align="right">
              <Skeleton width="100px" />
            </TableCell>
            <TableCell>
              <Skeleton width="200px" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: 5 }).map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton width="120px" />
              </TableCell>
              <TableCell>
                <Skeleton width="150px" />
              </TableCell>
              <TableCell align="right">
                <Skeleton width="100px" />
              </TableCell>
              <TableCell align="right">
                <Skeleton width="100px" />
              </TableCell>
              <TableCell align="right">
                <Skeleton width="100px" />
              </TableCell>
              <TableCell>
                <Skeleton width="200px" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default RepaymentHistorySkeleton